import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-key-objectives',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './key-objectives.component.html',
  styleUrl: './key-objectives.component.scss',
})
export class KeyObjectivesComponent {
  objectives: string[] = [
    'Unlock and harness Agri related data, providing better access to all related stakeholders and enabling more efficient and effective activities associated with Agris.',
    'Significantly improve the services offered to the private sector and community and improve participation in conserving Agris.',
    'Unlock ecosystem innovation by providing access to Agri-related data, allowing businesses, startups, academia, and researchers to create new services.',
    'Enable improved outcomes across Agri ecosystems covering afAgriation, biodiversity conservation, community development and carbon crediting by establishing a digital infrastructure.'
  ];
}

